import { InView } from 'react-intersection-observer';
import style from '../knear.module.scss'
import animations from '@styles/animations.module.scss'
import { ProjectInfoPoint } from '../knear-state';

interface ProjectInfoSectionProps {
    title: string;
    points: Array<ProjectInfoPoint>;
}
const ProjectInfoSection = ({ title, points }: ProjectInfoSectionProps) => {
    return (
        <section className={`${style.section}`}>
            <div className={`${style.container}`}>
                <div className={`${style.container__flex}`}>
                    <InView triggerOnce={true}>
                        {({ inView, ref, entry }: any) => {
                            if (inView) {
                                entry?.target.classList.add(animations.active);
                            }
                            return (
                                <div ref={ref} className={`${style.container__list__title} ${style.container__title} ${style.container__title_left} ${animations.scroll__animation}`}>
                                    {title}
                                </div>
                            )
                        }}
                    </InView>
                    <div className={style.container__list}>
                        {points.map((item: any, index: number) => {
                            return (
                                <div className={style.container__list__info} key={index}>
                                    <InView triggerOnce={true}>
                                        {({ inView, ref, entry }: any) => {
                                            if (inView) {
                                                entry?.target.classList.add(animations.active);
                                            }
                                            return (
                                                <div
                                                  ref={ref}
                                                  className={`${style.container__subtitle} ${animations.scroll__animation}`}
                                                  style={{textAlign: 'left'}}
                                                >
                                                    {item.title}
                                                </div>
                                            )
                                        }}
                                    </InView>
                                    <InView triggerOnce={true}>
                                        {({ inView, ref, entry }: any) => {
                                            if (inView) {
                                                entry?.target.classList.add(animations.active);
                                            }
                                            return (
                                                <div
                                                  ref={ref}
                                                  className={`${style.container__title_small} ${style.container__subtitle_left} ${animations.scroll__animation}`}
                                                >
                                                    {item.subtitle}
                                                </div>
                                            )
                                        }}
                                    </InView>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ProjectInfoSection;
